import React from "react";
import { Steps, Row, Col } from "antd";

const { Step } = Steps;

interface CodeIdentifierStepsProps {
  currentStep: number;
  onStepChange: (step: number) => void;
}

const CodeIdentifierSteps: React.FC<CodeIdentifierStepsProps> = ({
  currentStep,
  onStepChange
}) => {
  return (
    <Row justify="center" style={{ marginBottom: "24px" }}>
      <Col xs={24} sm={24} md={18} lg={16} xl={14}>
        <Steps current={currentStep} onChange={onStepChange}>
          <Step title="Upload Files" />
          <Step title="Identify Codes" />
        </Steps>
      </Col>
    </Row>
  );
};

export default CodeIdentifierSteps; 